module.exports = __webpack_public_path__ + "static/media/992499.d04c19b4.png";